// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import MDButton from "theme/components/MDButton";
import MDInput from "theme/components/MDInput";
import { PinInput } from "react-input-pin-code";
import usePageTitle from "app/pageTitle";
import CompanyNotification from "app/company_notification";

// import OTPInput from "otp-input-react";

// import { useMaterialUIController } from "context";

function CreateTransferPayout() {
  const pageTitle = "Send Money";
  usePageTitle(pageTitle);

  const navigate = useNavigate();
  // const [controller] = useMaterialUIController();
  // const { darkMode } = controller;

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  // const [OTP, setOTP] = useState("");

  const [openConfirmDialog, setConfirmDialog] = useState(false);
  const [openStatusDialog, setStatusDialog] = useState(false);
  const [statusMessage, setStatusMessage] = useState(
    "Your transfer has been submitted successfully. This may take a few moments to process."
  );

  const [currencies, setCurrencies] = useState([]);
  const [currency, setCurrency] = useState(null);
  // const [incomeSources, setIncomeSources] = useState([]);
  const [transferAmountText, setTransferAmountText] = useState("Amount");
  const [beneficiaryName, setBeneficiaryName] = useState("");

  const [userPin, setUserPin] = useState(null);
  const [pinValues, setPinValues] = useState(["", "", "", ""]);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const [showCompanyNotification, setShowCompanyNotification] = useState(false);
  const [companyNotification, setCompanyNotification] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("users/payouts/internal/create/init.json")
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setCurrencies(result.data.data.result.currencies);
            // setIncomeSources(result.data.data.result.income_sources);

            if (result.data.notification) {
              setCompanyNotification(result.data.notification);
              if (result.data.notification.pages.includes("ALL")) {
                setShowCompanyNotification(true);
              } else if (result.data.notification.pages.includes("transfer-alero")) {
                setShowCompanyNotification(true);
              }
            }
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg("An error occurred. Please try again in a few moments.");
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  const [state, setState] = useState({});
  const {
    incomeSource = "savings",
    transferAmount = 0,
    transferNarration = null,
    // pin = null,
    beneficiary = null,
  } = state;

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  const handleCurrencyChange = (currencyCode) => {
    setCurrency(currencyCode);
  };

  useEffect(() => {
    const curText = currency === null ? "Amount" : `${currency} Amount`;
    setTransferAmountText(curText);
  }, [currency]);

  const postData = async (params) => {
    setShowLoading(true);
    await axios
      .post("users/payouts/create.json", params)
      .then((response) => {
        setShowLoading(false);
        if (response.data.status === "success") {
          setSeverity("success");
          const msg =
            "Transfer request received. This may take a few moments to process successfully.";
          setErrMsg(msg);
          setOpen(true);

          setStatusMessage(msg);
          setStatusDialog(true);
        } else {
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg("An error occurred. Please try again in a few moments.");
        setOpen(true);
        setShowLoading(false);
      });
  };

  const handleSubmit = () => {
    if (beneficiary === null) {
      setSeverity("error");
      setErrMsg("Enter your beneficiary's hashtag, Email or Account ID");
      setOpen(true);
      return;
    }

    if (beneficiaryName === "") {
      setSeverity("error");
      setErrMsg("Beneficiary name not confirmed.");
      setOpen(true);
      return;
    }

    if (currency === null) {
      setSeverity("error");
      setErrMsg("Transfer currency is required");
      setOpen(true);
      return;
    }

    if (incomeSource === null) {
      setSeverity("error");
      setErrMsg("Please indicate an income source for funds to be transfered.");
      setOpen(true);
      return;
    }

    if (transferAmount === null || transferAmount === 0) {
      setSeverity("error");
      setErrMsg("Please enter an amount to transfer.");
      setOpen(true);
      return;
    }

    if (transferNarration === null || transferNarration === "") {
      setSeverity("error");
      setErrMsg("A narration of transfer is required");
      setOpen(true);
      return;
    }

    setPinValues(["", "", "", ""]);
    setShowConfirmDialog(true);
  };

  function confirmSubmit() {
    const params = {
      currency: `${currency}`,
      income_source: incomeSource,
      beneficiary_name: beneficiaryName,
      beneficiary: `${beneficiary}`,
      beneficiary_type: "individual",
      transfer_type: "user",
      amount: transferAmount * 100,
      narration: transferNarration,
      pin: userPin,
    };
    // console.log(params);
    postData(params);
  }

  const getBeneficiaryName = async (accountIdentifier) => {
    setBeneficiaryName("");
    setShowLoading(true);
    const params = {
      type: "alero",
      search: {
        destination: accountIdentifier,
      },
    };
    await axios
      .post("users/payouts/name/search.json", params)
      .then((response) => {
        setShowLoading(false);
        if (response.data.status === "success") {
          setBeneficiaryName(response.data.data.name);
        } else {
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg("Unable to resolve beneficiary name.");
        setOpen(true);
        setShowLoading(false);
      });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      {companyNotification !== null && showCompanyNotification ? (
        <CompanyNotification
          title={companyNotification.title}
          description={companyNotification.description}
        />
      ) : (
        <> </>
      )}
      <Dialog open={showConfirmDialog}>
        <DialogTitle>Authorize Transaction</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <MDTypography variant="h6" fontWeight="light">
              Enter your pin to authorize transaction.
            </MDTypography>
            <MDBox mt={2}>
              <PinInput
                values={pinValues}
                onChange={(value, index, values) => setPinValues(values)}
                length={4}
                mask
                autoTab
                placeholder="-"
                onComplete={(text) => {
                  let up = "";
                  text.forEach((itm) => {
                    up += itm;
                  });
                  setUserPin(up);
                }}
              />
            </MDBox>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <MDButton
            color="warning"
            variant="outlined"
            onClick={() => {
              setShowConfirmDialog(false);
            }}
          >
            Cancel
          </MDButton>
          <MDButton
            color="success"
            variant="outlined"
            onClick={() => {
              if (userPin !== null && userPin.length === 4) {
                setShowConfirmDialog(false);
                setConfirmDialog(true);
              }
            }}
          >
            Proceed
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openConfirmDialog}>
        <DialogTitle>Confirm Transfer</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <MDTypography variant="text" color="dark">
              Are you sure you want to proceed with this transfer?
            </MDTypography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <MDButton
            color="warning"
            variant="outlined"
            onClick={() => {
              setConfirmDialog(false);
            }}
          >
            Cancel
          </MDButton>
          <MDButton
            color="success"
            variant="outlined"
            onClick={() => {
              setConfirmDialog(false);
              confirmSubmit();
            }}
          >
            Proceed
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openStatusDialog}>
        <DialogTitle>Funds Sent</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <MDTypography variant="text" color="dark">
              {statusMessage}
            </MDTypography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <MDButton
            color="success"
            variant="outlined"
            onClick={() => {
              setStatusDialog(false);
              navigate("/transfers");
            }}
          >
            Close
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {/* <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12}>
                <MDBox sx={{ marginBottom: "40px" }}>
                  <MDBox display="flex" alignItems="center" justifyContent="space-between">
                    <MDBox>
                      <MDButton
                        variant="link"
                        color={darkMode ? "white" : "dark"}
                        onClick={() => {
                          navigate("/payouts");
                        }}
                      >
                        My Transfers
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Grid>
            </Grid> */}
            <Grid
              container
              spacing={1}
              display="flex"
              alignItems="center"
              justifyContent="space-evenly"
            >
              <Grid item xs={12} md={7} lg={7}>
                <MDBox>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={3}>
                      <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                        Alero Transfer
                      </MDTypography>
                      <MDBox mt={1}>
                        <MDTypography variant="h6" fontWeight="light">
                          Send money instantly to anyone on Alero for free.
                        </MDTypography>
                      </MDBox>
                      <MDBox mt={5}>
                        <MDBox mb={1}>
                          <MDBox mb={3}>
                            <FormControl sx={{ minWidth: 120, width: "100%" }}>
                              <MDInput
                                type="text"
                                name="beneficiary"
                                label="Alero ID / Email Address / Hashtag"
                                sx={{ minWidth: 120, width: "100%" }}
                                onChange={handleChange}
                                onBlur={(e) => {
                                  getBeneficiaryName(e.target.value);
                                }}
                              />
                            </FormControl>
                          </MDBox>
                          <MDBox mb={3}>
                            <FormControl sx={{ minWidth: 120, width: "100%" }}>
                              <MDInput
                                readOnly
                                disabled
                                type="text"
                                name="beneficiary_name"
                                label="Beneficiary Name"
                                sx={{ minWidth: 120, width: "100%" }}
                                value={beneficiaryName}
                              />
                            </FormControl>
                          </MDBox>
                          <Grid container spacing={5}>
                            <Grid item xs={3} md={3} lg={3}>
                              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                <InputLabel>Currency</InputLabel>
                                <Select
                                  label="Currency"
                                  onChange={(e) => {
                                    setCurrency(e.target.value);
                                    handleCurrencyChange(e.target.value);
                                  }}
                                  sx={{ padding: "12px", paddingLeft: "3px" }}
                                >
                                  {
                                    // --> Notice below changes
                                    currencies.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                      currencies.map((record) => {
                                        if (record.swap_enabled) {
                                          return (
                                            <MenuItem value={record.currency_code}>
                                              {record.currency_code}
                                            </MenuItem>
                                          );
                                        }
                                        return null;
                                      })
                                  }
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={9} md={9} lg={9}>
                              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                <MDInput
                                  type="number"
                                  name="transferAmount"
                                  label={transferAmountText}
                                  sx={{ minWidth: 120, width: "100%" }}
                                  onChange={handleChange}
                                />
                              </FormControl>
                              {/* <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                <InputLabel>Income Source</InputLabel>
                                <Select
                                  name="incomeSource"
                                  onChange={handleChange}
                                  label="Income Source"
                                  // onChange={(e) => handleCurrencyChange(e.target.value)}
                                  sx={{ padding: "12px", paddingLeft: "3px" }}
                                >
                                  {
                                    // --> Notice below changes
                                    incomeSources.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                      incomeSources.map((record) => (
                                        <MenuItem value={record.code}>{record.title}</MenuItem>
                                      ))
                                  }
                                </Select>
                              </FormControl> */}
                            </Grid>
                          </Grid>
                          {/* <MDBox mt={3}>
                            <FormControl sx={{ minWidth: 120, width: "100%" }}>
                              <MDInput
                                type="number"
                                name="transferAmount"
                                label={transferAmountText}
                                sx={{ minWidth: 120, width: "100%" }}
                                onChange={handleChange}
                              />
                            </FormControl>
                          </MDBox> */}
                          <MDBox mt={3}>
                            <FormControl sx={{ minWidth: 120, width: "100%" }}>
                              <MDInput
                                onChange={handleChange}
                                name="transferNarration"
                                label="Narration"
                                sx={{ minWidth: 120, width: "100%" }}
                              />
                            </FormControl>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
                <MDBox mt={3}>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={2} sx={{ textAlign: "right" }}>
                      <MDButton
                        variant="contained"
                        color="dark"
                        onClick={() => {
                          // setConfirmDialog(true);
                          handleSubmit();
                        }}
                      >
                        Transfer Funds
                      </MDButton>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CreateTransferPayout;
